import {
  POSATypeJavascriptDTO,
  POSA_FORMAT
} from "@tootsweet/model/lottery/POSAType";

export default function (
  format: POSA_FORMAT,
  posaTypes: POSATypeJavascriptDTO[],
  hasCustomPOSAFeature: boolean
) {
  const nonCustomPOSA = posaTypes
    .filter((type: POSATypeJavascriptDTO) => type.format === format)
    .filter((type: POSATypeJavascriptDTO) => {
      return !type.isCustom;
    });

  const customPOSAList = posaTypes?.filter((posa) => {
    return posa.isCustom && posa.format === format;
  });

  const posaList: POSATypeJavascriptDTO[] = [];

  if (hasCustomPOSAFeature) {
    posaList.push(...customPOSAList);
  }

  posaList.push(...nonCustomPOSA);

  return posaList;
}
